import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceDetailsComponent } from './marketplace-details.component';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule, IfItemEnabled } from '@fgb/portal-component-library/src/lib/directives';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { FormsModule } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { RewardStatusComponent } from '@fgb/portal-component-library/src/lib/loyalty/reward-status';
import { MarketplaceActionsModule } from './marketplace-actions/marketplace-actions.module';
import { MarketplaceAttributesModule } from './marketplace-attributes/marketplace-attributes.module';
import { MarketplaceCustomFieldsModule } from './marketplace-custom-fields/marketplace-custom-fields.module';
import { MarketplacePurchaseConfirmationModule } from './marketplace-purchase-confirmation/marketplace-purchase-confirmation.module';
import { ErrorComponent } from '@fgb/portal-component-library/src/lib/shared/errors';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { SocialShareModalModule } from '@fgb/portal-component-library/src/lib/shared/social-share-modal';

@NgModule({
  declarations: [MarketplaceDetailsComponent],
  imports: [
    CommonModule,
    PipesModule,
    LoadingModule,
    ShortLongDescriptionModule,
    LoyaltyIconModule,
    CountdownModule,
    DirectivesModule,
    FormsModule,
    IfItemEnabled,
    RewardStatusComponent,
    MarketplaceActionsModule,
    MarketplaceAttributesModule,
    MarketplaceCustomFieldsModule,
    MarketplacePurchaseConfirmationModule,
    FGBSharedModule,
    ErrorComponent,
    SocialShareModalModule,
  ],
  exports: [MarketplaceDetailsComponent],
})
export class MarketplaceDetailsModule {}
